import axios from './client';

const NOTIFICATION_EMAIL_OPTIONS = '/notification/email';


// eslint-disable-next-line import/prefer-default-export
export function getNotificationEmailOptions() {
  return axios.get(NOTIFICATION_EMAIL_OPTIONS);
}
